import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Select from "react-select";
import axios from "axios";

function Edit_details() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const [searchParams, setSearchParams] = useSearchParams();
  const [uid, setuid] = useState(searchParams.get("userId"));
  const [f_name, setf_name] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [accountnumber, setaccountnumber] = useState("");
  const [accountaddress, setaccountaddress] = useState("");
  const [holdername, setHoldername] = useState("");
  const [bankname, setBankname] = useState("");
  const [branchname, setBranchname] = useState("");
  const [panno, setPanno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [upino, setUpino] = useState("");
  const [ifsccode, setIfsccode] = useState("");
  const [counrtyid, setcounrtyid] = useState("");

  const [counrtyName, setcounrtyName] = useState("");
  const [IP, setIP] = useState("");

  const [stateID, setStateID] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtID, setDistrictID] = useState("");
  const [districtname, setDistrictname] = useState("");
  const [pincode, setPincode] = useState("");
  const [password, setPassword] = useState("");
  const [trans_password, settrans_password] = useState("");
  const [secretkey, setsecretkey] = useState("");
  const [nomineename, setNomineename] = useState("");
  const [nomineerelation, setNomineerelation] = useState("");

  const [Countries, setCountries] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);

  useEffect(() => {
    const GetIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIP(response.data.ip);
      } catch {
        toast.error("Error in getting IP");
      }
    };
    GetIp();
  }, []);

  const CountryList_API = async () => {
    try {
      let res = await API.get(`countryList`);
      const fetchedCountries = res.data.data[0];
      setCountries(fetchedCountries);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const checkCountry = (e) => {
    const selectedCountryId = Number(e.target.value);
    const selectedCountry = Countries.find(
      (country) => parseInt(country.id) === parseInt(selectedCountryId)
    );
    console.clear();
    console.log("selectedCountryId-->", selectedCountryId);
    console.log("Countries-->", Countries);
    console.log("selectedCountry-->", selectedCountry);
    if (selectedCountry) {
      alert(selectedCountry.id);
      setcounrtyid(selectedCountry.id);
      setcounrtyName(selectedCountry.name);
      StateList_API(selectedCountry.id);
    }
  };

  const checkState = (e) => {
    const selectedStateId = Number(e.target.value);
    const selectedState = stateList.find(
      (State) => State.id === selectedStateId
    );

    if (selectedState) {
      setStateID(selectedState.id);
      setStateName(selectedState.name);
      DistrictList_API(selectedState.id);
    }
  };

  const checkDistrict = (e) => {
    const selecteddistrictId = Number(e.target.value);
    const selecteddistrict = districtList.find(
      (district) => district.id === selecteddistrictId
    );

    if (selecteddistrict) {
      setDistrictID(selecteddistrict.id);
      setDistrictname(selecteddistrict.name);
    }
  };

  const StateList_API = async (counrtyid) => {
    // console.log("CountryId", counrtyid);
    try {
      let response = await API?.post("getregion", {
        uid: userId,
        regiontype: "State",
        regionid: counrtyid,
      });
      // console.log("responsestate-->", counrtyid, response.data.data[0]);
      const fetchedStates = response.data.data[0];

      setstateList(fetchedStates);
    } catch (error) {
      console.log("state API ERROR", error);
    }
  };

  const DistrictList_API = async (stateID) => {
    try {
      let response = await API?.post("getregion", {
        uid: userId,
        regiontype: "district",
        regionid: stateID,
      });
      console.log("responsedis-->", response.data.data[0]);
      const fetcheddistrict = response.data.data[0];
      setdistrictList(fetcheddistrict);
    } catch (error) {
      console.log("District API ERROR", error);
    }
  };

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/GetUserProfile",
        {
          uid: uid,
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      //console.log("referral_API", responceRight.data);
      responceRight = responceRight.data.data[0][0];

      setuid(responceRight.uid);
      setf_name(responceRight.f_name);
      setEmail(responceRight.email);
      setMobile(responceRight.mobile);
      setaccountaddress(responceRight.accountaddress);
      setaccountnumber(responceRight.accountnumber);
      setBankname(responceRight.bank_name);
      setBranchname(responceRight.branch);
      setIfsccode(responceRight.ifsc);
      setHoldername(responceRight.holder);
      setcounrtyid(responceRight.countryid);
      setcounrtyName(responceRight.countryname);
      setStateID(responceRight.stateid);
      setStateName(responceRight.statename);
      setDistrictID(responceRight.districtid);
      setDistrictname(responceRight.districtname);
      setPincode(responceRight.pincode);
      StateList_API(responceRight.countryid);
      DistrictList_API(responceRight.stateid);
      setPanno(responceRight.PAN);
      setAadharno(responceRight.AAdhar);
      setUpino(responceRight.GPay);
      setNomineename(responceRight.nominee_name);
      setNomineerelation(responceRight.nominee_relation);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Update_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountaddress: accountaddress,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          IP_address: IP,
          secretkey: secretkey,
          nomineename: nomineename,
          nomineerelation: nomineerelation,
          type: "profileupdate",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      // console.log("Update_Api", responceRight.data.data);
      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const UpdatePassword_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountaddress: accountaddress,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          type: "password",
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const Updatetrans_password_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountaddress: accountaddress,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          type: "trans_password",
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const UpdateBnbAddress_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountaddress: accountaddress,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          secretkey: secretkey,
          type: "ecurrency",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const UpdateBankDetails_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          accountaddress: accountaddress,
          accountnumber: accountnumber,
          holdername: holdername,
          bankname: bankname,
          branchname: branchname,
          ifsccode: ifsccode,
          secretkey: secretkey,
          panno: panno,
          aadharno: aadharno,
          upino: upino,
          type: "bankdetails",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      if (responceRight.data.data === "Bank Details Updated Successfully") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
    CountryList_API();
  }, []);

  const [validName, setvalidName] = useState(true);
  const handleName = (e) => {
    const result = e.target.value.replace(/[^a-z ]/gi, "");
    setf_name(result);

    e.target.value ? setvalidName(true) : setvalidName(false);
  };

  const [validmobile, setValidMobile] = useState(true);
  const handleMobile = (e) => {
    const result = e.target.value.replace(/[^0-9]/gi, "");
    setMobile(result);

    e.target.value.indexOf("0") === 0
      ? setValidMobile(false)
      : e.target.value.length <= 9
      ? setValidMobile(false)
      : setValidMobile(true);
  };

  const [valid, setValid] = useState(true);
  const EmailValidation = (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(inputValue);
    setValid(isValid);
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Edit Member Details</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                {/* <div className="d-flex justify-content-between">
                                  <a
                                    href="/Funds_Details"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    
                                  </a>
                                </div> */}
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Name"
                                    value={uid}
                                    readOnly
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Name"
                                    value={f_name}
                                    onChange={(e) => handleName(e)}
                                  />
                                  {!validName && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Name.
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Email Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => EmailValidation(e)}
                                  />
                                  {!valid && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Email.
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Mobile No</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Mobile Number"
                                    value={mobile}
                                    onChange={(e) => handleMobile(e)}
                                  />
                                  {!validmobile && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Mobile No.
                                    </p>
                                  )}
                                </div>
                                {/* <div className="form-group">
                                  <label>Wallet Address</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Wallet Address"
                                    value={accountnumber}
                                    onChange={(e) =>
                                      setaccountnumber(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="form-group">
                                  <label>Country Name</label>
                                  <select
                                    name="country"
                                    className="form-control"
                                    value={counrtyid}
                                    onChange={checkCountry}
                                  >
                                    <option value="" disabled>
                                      Select Country
                                    </option>
                                    {Countries.map((country) => (
                                      <option
                                        key={country.id}
                                        value={country.id.toString()}
                                      >
                                        {country.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="form-group">
                                  <label>State Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter State Name"
                                    maxLength={20}
                                    value={stateName}
                                    onChange={(e) =>
                                      setStateName(e.target.value)
                                    }
                                  />
                                  {/* <select
                                    name="state"
                                    className="form-control"
                                    value={stateID}
                                    onChange={checkState}
                                  >
                                    <option value="" disabled>
                                      Select State
                                    </option>
                                    {stateList.map((state) => (
                                      <option
                                        key={state.id}
                                        value={state.id.toString()}
                                      >
                                        {state.name}
                                      </option>
                                    ))}
                                  </select> */}
                                </div>
                                <div className="form-group">
                                  <label>District Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter District Name"
                                    maxLength={20}
                                    value={districtname}
                                    onChange={(e) =>
                                      setDistrictname(e.target.value)
                                    }
                                  />
                                  {/* <select
                                    name="state"
                                    className="form-control"
                                    value={districtID}
                                    onChange={checkDistrict}
                                  >
                                    <option value="" disabled>
                                      Select State
                                    </option>
                                    {districtList.map((district) => (
                                      <option
                                        key={district.id}
                                        value={district.id.toString()}
                                      >
                                        {district.name}
                                      </option>
                                    ))}
                                  </select> */}
                                </div>

                                <div className="form-group">
                                  <label>Pin Code</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Pin Code"
                                    maxLength={6}
                                    value={pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Nominee Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Nominee Name"
                                    maxLength={30}
                                    value={nomineename}
                                    onChange={(e) =>
                                      setNomineename(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Nominee Relation</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Nominee Relation"
                                    maxLength={20}
                                    value={nomineerelation}
                                    onChange={(e) =>
                                      setNomineerelation(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactive"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => Update_Api()}
                                      disabled={
                                        valid && validName ? false : true
                                      }
                                    >
                                      Update Profile
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Account Number</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Account Number"
                                    value={accountnumber}
                                    onChange={(e) =>
                                      setaccountnumber(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Account Holder Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Account Holder Name"
                                    value={holdername}
                                    onChange={(e) =>
                                      setHoldername(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>IFSC Code</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Ifsc Code"
                                    value={ifsccode}
                                    onChange={(e) =>
                                      setIfsccode(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Bank Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Bank Name"
                                    value={bankname}
                                    onChange={(e) =>
                                      setBankname(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Branch Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Branch Name"
                                    value={branchname}
                                    onChange={(e) =>
                                      setBranchname(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>PAN Number</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter PAN Number"
                                    value={panno}
                                    onChange={(e) => setPanno(e.target.value)}
                                    maxLength={10}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Aadhar Number</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Aadhar Number"
                                    value={aadharno}
                                    onChange={(e) =>
                                      setAadharno(e.target.value)
                                    }
                                    maxLength={12}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>UPI Number</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter UPI Number"
                                    value={upino}
                                    onChange={(e) => setUpino(e.target.value)}
                                    maxLength={12}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdateBankDetails_Api()}
                                    >
                                      Update Bank Details
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Password</label>
                                  <input
                                    type="password"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Transaction Password</label>
                                  <input
                                    type="text"
                                    id="transpassword"
                                    class="form-control"
                                    placeholder="Enter Transaction Password"
                                    value={transpassword}
                                    onChange={(e) =>
                                      settranspassword(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdatePassword_Api()}
                                    >
                                      Update Password
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Transction Password</label>
                                  <input
                                    type="password"
                                    id="txttranspass"
                                    class="form-control"
                                    placeholder="Enter Transction Password"
                                    value={trans_password}
                                    onChange={(e) =>
                                      settrans_password(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Transaction Password</label>
                                  <input
                                    type="text"
                                    id="transpassword"
                                    class="form-control"
                                    placeholder="Enter Transaction Password"
                                    value={transpassword}
                                    onChange={(e) =>
                                      settranspassword(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswdtrans"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => Updatetrans_password_Api()}
                                    >
                                      Update Tansction Password
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>USDT BEP 20 Address</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Wallet Address"
                                    value={accountaddress}
                                    onChange={(e) =>
                                      setaccountaddress(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdateBnbAddress_Api()}
                                    >
                                      Update USDT BEP 20 Address
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit_details;
